<template>
  <div class="header__inner w-full !grid desktop:!hidden items-center z-[1]">
    <Breadcrumbs v-if="route.meta.baseRoute !== 'clientPillars'" />
    <ContentPillarsBreadcrumbs v-else />
    <Sidebar />
    <HeaderMobileBurger />
  </div>
</template>
<script setup>
import Breadcrumbs from '@/components/breadcrumbs/Breadcrumbs'
import HeaderMobileBurger from '@/components/header/HeaderMobileBurger'
import Sidebar from '@/components/sidebar/Sidebar'
import ContentPillarsBreadcrumbs from '@/views/client/content-pillars/header/Breadcrumbs'
import { useRoute } from 'vue-router'

const route = useRoute()
</script>
